import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import Indentation from '../../../../components/Simple/Indentation';
import SMCPasswordInput from '../../../../components/Simple/SMCPasswordInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCNumberInput from "../../../../components/Simple/SMCNumberInput";

const pageSchema = SystemSettingsGetSchema.pages.mail;
const pageId = pageSchema.pageId;

function SystemSettingsMail({
    systemSettingsObject,
    setSystemSettingsData
}) {
    const { t } = useTranslation();

    const pageData = systemSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSystemSettingsData([pageId, paramName], value);
    }, [setSystemSettingsData]);

    const mailHost        = pageData[pageSchema.mailHost];
    const mailSupport     = pageData[pageSchema.mailSupport];
    const mailSupportName = pageData[pageSchema.mailSupportName];
    const isMailSMTPAuth  = pageData[pageSchema.isMailSMTPAuth];
    const mailUser        = pageData[pageSchema.mailUser];
    const mailPassword    = pageData[pageSchema.mailPassword];
    const mailPort        = pageData[pageSchema.mailPort];
    const mailRequireTLS  = pageData[pageSchema.mailRequireTLS];    

    return (
        <EditorLayout>
            <SMCTextInput
                value={mailHost}
                onChange={e => setPageValue(pageSchema.mailHost, e.target.value)}
                label={t('SMP.SETTINGS.MAIL_SETTINGS.SMTP_SERVER')}
            />
            <SMCTextInput
                value={mailSupport}
                onChange={e => setPageValue(pageSchema.mailSupport, e.target.value)}
                label={t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL')}
                tooltip={<>{t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE1')} <b>{t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE2')}</b> {t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE3')}</>}
            />
            <SMCTextInput
                value={mailSupportName}
                onChange={e => setPageValue(pageSchema.mailSupportName, e.target.value)}
                label={t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY')}
                tooltip={<>{t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE1')} <b>{t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE2')}</b> {t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE3')}</>}
            />

            <SMCCheckbox
                checked={isMailSMTPAuth}
                onChange={e => setPageValue(pageSchema.isMailSMTPAuth, e.target.checked)}
                label={t('SMP.SETTINGS.MAIL_SETTINGS.USE_AUTH_SMTP')}
            />
            {
                isMailSMTPAuth && (
                    <Indentation>
                        <SMCTextInput
                            value={mailUser}
                            onChange={e => setPageValue(pageSchema.mailUser, e.target.value)}
                            label={t('SMP.SETTINGS.MAIL_SETTINGS.USE_AUTH_SMTP.USER')}
                            />
                        <SMCPasswordInput
                            value={mailPassword}
                            onChange={e => setPageValue(pageSchema.mailPassword, e.target.value)}
                            label={t('SMP.SETTINGS.MAIL_SETTINGS.USE_AUTH_SMTP.PASSWORD')}
                            allowPasswordPeek={true}
                        />
                    </Indentation>
                )
            }
            <RowLayout>
                <SMCNumberInput
                    value={mailPort}
                    label={t('SMP.SETTINGS.MAIL_SETTINGS.USE_AUTH_SMTP.PORT')}
                    onChange={e => setPageValue(pageSchema.mailPort, e.target.value)}
                    width={70}
                />
            </RowLayout>    
            <RowLayout>
                <SMCCheckbox
                    checked={mailRequireTLS}
                    onChange={e => setPageValue(pageSchema.mailRequireTLS, e.target.checked)}
                    label={t('SMP.SETTINGS.MAIL_SETTINGS.USE_AUTH_SMTP.ENFORCETLS')}
                />
            </RowLayout>                      
        </EditorLayout>
    )
}

export default SystemSettingsMail;